import { SeriesElement } from './SeriesElement';
import { Patient } from './Patient';
import { ViewStudy } from '../view/view-study';
import { sortBy } from 'lodash-es';

export class Patients {
    data: Map<string, Patient>;

    constructor() {
        this.data = new Map();
    }

    addSeriesElement(e: SeriesElement) {
        let patient: Patient | undefined = this.data.get(e.getPatientId());
        if (!patient) {
            patient = new Patient(e);
            this.data.set(e.getPatientId(), patient);
        }
        patient.addSeriesElement(e);
    }

    generateViewStudies(): ViewStudy[] {
        return sortBy(
            [...this.data.values()]
                .map((e: Patient) => e.convertToViewStudy())
                .reduce((acc, cur) => acc.concat(cur), []),
            (s) => s.data.id,
        );
    }
}
